const inspectType= [
    {
        code: '1',
        label: '前期检查'
    },
    {
        code: '3',
        label: '中期检查'
    },
    {
        code: '5',
        label: '答辩前检查'
    },
    {
        code: '7',
        label: '答辩检查'
    },
    {
        code: '9',
        label: '综合检查'
    },
    {
        code: '11',
        label: '校优'
    },
    {
        code: '13',
        label: '省优'
    },
    {
        code: '15',
        label: '省抽检'
    },
    
]

export default {
    inspectType
}